import type { Language } from "../types";
import businessData from "./business.json";

export const business = businessData;

export const mapEmbedUrl = `https://www.google.com/maps?q=${business.latitude},${business.longitude}&z=16&output=embed`;

export const businessLinks = {
  phone: `tel:${business.phone}`,
  email: `mailto:${business.email}`,
  whatsapp: `https://wa.me/${business.whatsapp.replace(/\D/g, "")}`,
  maps: business.mapsUrl,
} as const;

export const whatsappUrl = (message: string) =>
  `${businessLinks.whatsapp}?text=${encodeURIComponent(message)}`;

export const productInquiryMessage = (name: string, lang: Language) =>
  lang === "ar"
    ? `مرحبًا ${business.businessNameAr}،\nأود الاستفسار عن توفر وسعر المنتج:\n${name}`
    : `Hello ${business.businessNameEn},\nI would like to ask about the availability and price of:\n${name}`;

export interface InquiryLine {
  name: string;
  quantity: number;
}

export const cartInquiryMessage = (
  items: InquiryLine[],
  lang: Language,
  details?: { name?: string; phone?: string; note?: string },
) => {
  const lines = items
    .map((item, index) =>
      lang === "ar"
        ? `${index + 1}. ${item.name} — الكمية: ${item.quantity}`
        : `${index + 1}. ${item.name} — Quantity: ${item.quantity}`,
    )
    .join("\n");
  const name = details?.name?.trim() || "";
  const phone = details?.phone?.trim() || "";
  const note = details?.note?.trim() || "";

  return lang === "ar"
    ? `مرحبًا ${business.businessNameAr}،\nأود الاستفسار عن توفر وأسعار المنتجات التالية:\n\n${lines}\n\nالاسم: ${name}\nرقم الهاتف: ${phone}${note ? `\nملاحظات: ${note}` : ""}\n\nشكرًا لكم.`
    : `Hello ${business.businessNameEn},\nI would like to ask about the availability and prices of the following products:\n\n${lines}\n\nName: ${name}\nPhone: ${phone}${note ? `\nNote: ${note}` : ""}\n\nThank you.`;
};

export const prescriptionInquiryMessage = (
  lang: Language,
  details?: { name?: string; phone?: string; note?: string },
) => {
  const suffix = details
    ? lang === "ar"
      ? `\n\nالاسم: ${details.name || ""}\nرقم الهاتف: ${details.phone || ""}${details.note ? `\nملاحظات: ${details.note}` : ""}`
      : `\n\nName: ${details.name || ""}\nPhone: ${details.phone || ""}${details.note ? `\nNotes: ${details.note}` : ""}`
    : "";
  return lang === "ar"
    ? `مرحبًا ${business.businessNameAr}،\nأرغب في إرسال وصفة طبية والاستفسار عن توفر المنتجات.${suffix}`
    : `Hello ${business.businessNameEn},\nI would like to send a prescription and ask about product availability.${suffix}`;
};
